import ApiService from "@/common/api.service"

export const AccreditedCpdPService = {
    getAccreditedCpdPService() {
        return ApiService.get("/accreditedCpdPReport")
    }

}